if (typeof window !== `undefined`) {
    // window check was needed to make sure nodejs does not try to load the .scss resource
}

export class ProgressOverlay {
    /**
     * Activates the ProgressOverlay
     * Call when you want to show the UI is waiting for server response
     */
    public static activate(message?: string) {
        // Deactivate any existing overlays
        this.deactivate();
        let showHelperText = '';
        if (message) {
            showHelperText = `<div class="tw-text-gray-100">${message}</div>`;
        }

        // Display overlay
        document
            .querySelector(`body`)
            .insertAdjacentHTML(
                `beforeend`,
                `<div class='progressOverlay tw-fixed tw-top-0 tw-left-0 tw-w-full tw-h-full tw-z-[1051] tw-bg-black tw-opacity-50 tw-flex tw-items-center tw-justify-center tw-flex-col'><div class='tw-block tw-border-4 tw-border-gray100 tw-border-r-gray-250 tw-border-l-gray-250 tw-border-b-gray-250 tw-rounded-[50%] tw-w-8 tw-h-8 tw-animate-spin tw-duration-75 tw-mt-4 tw-mx-auto'></div>${showHelperText}</div>`,
            );
    }

    /**
     * Deactivates the ProgressOverlay
     * Call when you want to return control
     */
    public static deactivate() {
        const elem = document.querySelector(`.progressOverlay`);
        if (elem) {
            elem.parentNode.removeChild(elem);
        }
    }
}
